import { c as _c } from "react/compiler-runtime";
import { STORES_API } from 'modules/stores/api/stores-api';
import { StoreId } from 'modules/stores/types/stores-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { OptinItemViewType } from '../../types/optin-interface';
export const useStoreOptinItemsList = (storeId, shouldFetch) => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== storeId) {
    t1 = () => !!storeId && `${STORES_API}/${storeId}/item-opt-ins/choice-list-tmp`;
    $[1] = storeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useControlledSwr(t1, fetcher, t2, Boolean(user && shouldFetch));
};